import { render, staticRenderFns } from "./SingPauseMitgliederContacts.vue?vue&type=template&id=427fab79&"
import script from "./SingPauseMitgliederContacts.vue?vue&type=script&lang=js&"
export * from "./SingPauseMitgliederContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports